import React from 'react';
import { RouteComponentProps } from 'react-router';
import { FortunaSpinWheelContainer } from '../../epic/fortuna-spin-wheel';

export const Page: React.FC<RouteComponentProps> = () => {
  return <FortunaSpinWheelContainer />;
};
